export default __webpack_public_path__ + "static/media/mu.d12bea5d.png";